module.exports = __webpack_public_path__ + "img/Apoptosis-LICA_GSE236681.16fb7bc3.png";